import type { AxiosResponse } from "axios";

import { getData } from "@/apis/apiInstance";

import type {
  getBankAccountNumberType,
  getGstInfoType,
  getIfscDataType,
  getPanAadharLinkStatusType,
  verifyPanType,
  verifyTanType,
} from "@/commonTypes/serviceTypes";

export async function verifyIfscApi(
  data: getIfscDataType
): Promise<AxiosResponse> {
  const { token, ifscNumber } = data;
  return await getData(`bank/ifsc/info`, {
    params: {
      ifsc_code: ifscNumber,
      company_id: 5,
    },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
    },
  });
}

export async function getGstInfo(data: getGstInfoType): Promise<AxiosResponse> {
  const { token, gstNumber } = data;
  return await getData(`gst/info`, {
    params: {
      gst_no: gstNumber,
      company_id: 5,
    },
    headers: {
      // "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getPanAadharLinkStatusApi(
  data: getPanAadharLinkStatusType
): Promise<AxiosResponse> {
  const { pan_no, aadhar_no, token } = data;

  return await getData(`pan_aadhar_link.php`, {
    params: {
      pan_no: pan_no,
      aadhar_no: aadhar_no,
      company_id: 5,
    },
    headers: {
      // "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getBankAccountInfoApi(
  data: getBankAccountNumberType
): Promise<AxiosResponse> {
  const { ifsc_no, account_number, token } = data;
  return await getData(`bank/verify/account/pennyless`, {
    params: {
      ifsc_code: ifsc_no,
      account_number,
      company_id: 5,
    },
    headers: {
      // "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function verifyPanApi(
  data: verifyPanType
): Promise<AxiosResponse> {
  const { panNo, token } = data;
  return await getData(`pan/info`, {
    params: {
      company_id: 5,
      pan_no: panNo,
    },
    headers: {
      // "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function verifyTanApi(
  data: verifyTanType
): Promise<AxiosResponse> {
  const { tanNo, token } = data;

  return await getData(`tan/info`, {
    params: {
      company_id: 5,
      tan_no: tanNo,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
